
export const FILTERS_MARKETS_USA = [
  "Healthcare",
  "Hospitality",
  "Education",
  "Office",
  "Residential",
  "Marine",
  "Automotive/RV"
]